/**
 * Sunucudan gelen ikili (blob) yanıtı dosya olarak kaydeder.
 *
 * NEDEN ORTAK BİR YARDIMCI: aynı altı satır (`createObjectURL` → `<a>` →
 * `click()` → `revokeObjectURL`) bu repoda sekiz yere kopyalanmış durumda
 * ve en az biri `revokeObjectURL`'ü atlıyor. Üç rapor indirmesi eklenirken
 * dokuzuncu kopya açılmadı.
 *
 * ASIL SEBEP — "AÇILMAYAN EXCEL" KAZASI: indirme uçları her zaman .xlsx
 * döndürmez. Yetki yoksa, ya da Dönem Geçişi raporunda kıyaslanacak iki
 * dönem yoksa, uç JSON döner (bazı durumlarda 200 ile). Blob doğrudan
 * kaydedilirse kullanıcının eline Excel'in açamadığı bir
 * `borc-raporu.xlsx` geçer ve sebebini hiçbir yerde görmez. Burada
 * blob'un MIME tipine bakılıp sunucunun mesajı okunuyor.
 */

/**
 * Yanıttaki dosya adını `Content-Disposition` başlığından çözer.
 *
 * Ad SUNUCUDA üretiliyor (tarih damgası dahil); burada ikinci bir kopyasını
 * kurmak iki yerin sapmasına davetiye olurdu. Başlık okunamazsa (tarayıcı
 * göstermezse) `yedek` kullanılıyor.
 */
export function dosyaAdiCoz(res, yedek) {
  const cd = res?.headers?.['content-disposition'] || '';
  const m = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(cd);
  if (!m) return yedek;
  try {
    return decodeURIComponent(m[1]);
  } catch (e) {
    // Bozuk yuzde kodlamasi: adi kaybetmek yerine ham halini kullan.
    return m[1];
  }
}

/**
 * Blob'u indirir. JSON geldiyse kaydetmez, sunucunun mesajıyla hata atar —
 * çağıran `message.error()` ile gösterebilsin.
 */
export async function blobuKaydet(blob, dosyaAdi) {
  if (blob && typeof blob.type === 'string' && blob.type.includes('json')) {
    let mesaj = '';
    try {
      mesaj = JSON.parse(await blob.text())?.message || '';
    } catch (e) {
      // JSON da okunamadiysa genel mesaja dusuyoruz.
    }
    throw new Error(mesaj || 'Dosya oluşturulamadı.');
  }

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = dosyaAdi;
  a.click();
  URL.revokeObjectURL(url);
}

/**
 * Tek çağrıda indirme: isteği atar, adı çözer, kaydeder.
 *
 * @param {Promise} istek    responseType: 'blob' ile yapılmış axios isteği
 * @param {string}  yedekAd  başlık okunamazsa kullanılacak dosya adı
 */
export async function raporIndir(istek, yedekAd) {
  const res = await istek;
  await blobuKaydet(res.data, dosyaAdiCoz(res, yedekAd));
}
